var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 42,
    rx: 6,
    fill: "url(#paint0_linear_10586_2007)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5758 16.5L32.4967 21H11.1312L12.0521 16.5H31.5758ZM34.093 9H9.53488V12H34.093V9ZM34.093 13.5H9.53488L8 21V24H9.53488V33H24.8837V24H31.0233V33H34.093V24H35.6279V21L34.093 13.5ZM12.6047 30V24H21.814V30H12.6047Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10586_2007",
    x1: -6.84091,
    y1: 2.40096e-7,
    x2: 37.5884,
    y2: 40.9802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BFF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918333,
    stopColor: "#5B93E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon);
export default __webpack_public_path__ + "static/media/merchant-icon.fc324541bb5181411d8d33af93358f33.svg";
export { ForwardRef as ReactComponent };